<template>
  <div>
    <el-breadcrumb v-show="(breadcrumb.length || !menuList.length) && $route.path !== '/board'" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/board' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index">{{ item.title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
        type: Array,
        default() {
          return []
        }
    }
  },
  computed: {
    breadcrumb() {
      let breadcrumb = []
      const path = this.$route.path
      this.menuList.some(menu => menu.children.some(child => {
        if ('/' + child.Component === path) {
          return breadcrumb.push({
            title: menu.Title,
            path: '/' + menu.Component
          }, {
            title: child.Title,
            path: '/' + child.Component
          })
        }
      }))
      return breadcrumb
    }
  }
}
</script>

<style lang="less" scoped>
</style>
